import { AUTH_REALM } from "@/constants";
import { isAdminHostname } from "@/shared/tenant/getTenantFromHostname";

export type AuthRealm = (typeof AUTH_REALM)[keyof typeof AUTH_REALM];

/** Maps the current hostname to tenant or admin Cognito realm. */
export function resolveAuthRealm(hostname = window.location.hostname): AuthRealm {
  return isAdminHostname(hostname) ? AUTH_REALM.ADMIN : AUTH_REALM.TENANT;
}

export function assertTenantAuthRealm(realm: AuthRealm): void {
  if (realm !== AUTH_REALM.TENANT) {
    throw new Error("Expected tenant auth realm.");
  }
}

export function assertAdminAuthRealm(realm: AuthRealm): void {
  if (realm !== AUTH_REALM.ADMIN) {
    throw new Error("Expected admin auth realm.");
  }
}
